import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators'
import { SharedService } from './sharedService';
import { map } from "rxjs/operators";
import { Process } from "../entities/process"
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};


@Injectable({
  providedIn: 'root'
})
export class ProcessService {
  getAttachments(processId: any, stageKey: any) {
    return this.http.get<any>(this.sharedService.apiUrl('process/attachments')+processId+'/'+stageKey).pipe(
      tap((attachments: any) => this.log(`getting attachments for process ${attachments}`)),
      catchError(this.handleError<any>('getting attachments'))
    );
  }

  constructor(private http: HttpClient, private sharedService: SharedService) { }
 
  getProcessMapping(processKey: string): Observable<Process> {
    let process$ = this.http.get<Process>(this.sharedService.apiUrl('process/mapping') + processKey)
    return process$;
  }
  
  getProcessingStages(process: any): Observable<any> {
    return this.http.get<any>(this.sharedService.apiUrl('process/processing-stages')+process, httpOptions).pipe(
      tap((process: any) => this.log(`processsing stages w/ id=${process}`)),
      catchError(this.handleError<any>('processsing stages'))
    );
  }

  getSummary(year: string,
    filter = '', sortOrder = 'asc', sortColumn = '',
    pageNumber = 0, pageSize = 10): Observable<any> {
    return this.http.get(this.sharedService.apiUrl('process/summary'), {
      params: new HttpParams()
        .set('year', year)
    }).pipe(
      map(res => {
        return res;
      })
    );
  }

  downloadPDF(report: any, processId: any): Observable<Blob> {

    const httpOptionsPDF = {
      headers: new HttpHeaders({ 'Accept': 'application/pdf', 'Content-Type': 'application/json' }),
      responseType: 'blob' as 'json',
      params: new HttpParams().set('report', report).set('id', processId).set('lang',localStorage.getItem('lang'))
    };
    let process$ = this.http.get<any>(this.sharedService.apiUrl('process/pdf'), httpOptionsPDF).pipe(
      map((res: Response) => res), catchError(this.handleError<any>('download pdf'))
    )
    return process$;

  }

  downloadExcel(report: any, processId: any): Observable<Blob> {

    const httpOptions = {
      params: new HttpParams().set('report', report).set('id', processId),
      responseType: 'blob' as 'json'
    };
    let process$ = this.http.get<any>(this.sharedService.apiUrl('process/excel'), httpOptions).pipe(
      map((res: Response) => { return res}), catchError(this.handleError<any>('download docflow file'))
    )
    return process$;


  }

  downloadUploadFile(name: any): Observable<Blob> {
    const httpOptionsPDF = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      responseType: 'blob' as 'json',
      params: new HttpParams().set('file', name)
    };
    let process$ = this.http.get<any>(this.sharedService.apiUrl('process/file'), httpOptionsPDF).pipe(
      map((res: Response) => res), catchError(this.handleError<any>('download file'))
    )
    return process$;

  }

  downloadMappingFile(name: any): Observable<Blob> {
    const httpOptionsPDF = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      responseType: 'blob' as 'json',
      params: new HttpParams().set('file', name)
    };
    let process$ = this.http.get<any>(this.sharedService.apiUrl('process/mapping'), httpOptionsPDF).pipe(
      map((res: Response) => res), catchError(this.handleError<any>('download file'))
    )
    return process$;

  }

  downloadFileFromDocflow (name: any): Observable<Blob> {

    const httpOptions = {
      params: new HttpParams().set('name', name),
      responseType: 'blob' as 'json'
    };
    let process$ = this.http.get<any>(this.sharedService.apiUrl('process/docflowfile'), httpOptions).pipe(
      map((res: Response) => { return res}), catchError(this.handleError<any>('download docflow file'))
    )
    return process$;

  }

  
  

  downloadEditingPDF(stage: any): Observable<Blob> {
    const httpOptionsPDF = {
      headers: new HttpHeaders({ 'Accept': 'application/pdf', 'Content-Type': 'application/json' }),
      responseType: 'blob' as 'json'    
    };
    let process$ = this.http.post<any>(this.sharedService.apiUrl('process/pdfediting'), {stage:stage}, httpOptionsPDF).pipe(
      map((res: Response) => res), catchError(this.handleError<any>('download pdfediting'))
    )
    return process$;

  }


  getProcesses(year: string,
    filter = '', sortOrder = 'asc', sortColumn = '',
    pageNumber = 0, pageSize = 10): Observable<Process[]> {
    return this.http.get(this.sharedService.apiUrl('process'), {
      
      params: new HttpParams()
        .set('year', year)
        .set('filter', filter)
        .set('sortOrder', sortOrder)
        .set('sortColumn', sortColumn.toString())
        .set('pageNumber', pageNumber.toString())
        .set('pageSize', pageSize.toString())
    }).pipe(
      map(res => {
        res['payload'] = res;
        return res["payload"];
      })
    );
  }
 

  getTaxPayersFromProcessSummary(year: string,
    filter = '', sortOrder = 'asc', sortColumn = '',
    pageNumber = 0, pageSize = 10, filterObject:any): Observable<Process[]> {
    return this.http.get(this.sharedService.apiUrl('process/taxpayerSummary'), {
      
      params: new HttpParams()
        .set('year', year)
        .set('filter', filter)
        .set('filter.object',JSON.stringify(filterObject))
        .set('sortOrder', sortOrder)
        .set('sortColumn', sortColumn.toString())
        .set('pageNumber', pageNumber.toString())
        .set('pageSize', pageSize.toString())
    }).pipe(
      map(res => {
        res['payload'] = res;
        return res["payload"];
      })
    );
  }

  getExcelReport(year, service, page): Observable<Blob> {

    const httpOptionsPDF = {
      headers: new HttpHeaders({ 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
      responseType: 'blob' as 'json',
      params: new HttpParams().set('year', year).set('key', service).set('page', page)
    };
    let process$ = this.http.get<any>(this.sharedService.apiUrl('process/page_excel'), httpOptionsPDF).pipe(
      map((res: Response) => res), catchError(this.handleError<any>('download excel'))
    )
    return process$;

  }

  getProcess(id: string): Observable<Process> {
    let process$ = this.http.get<Process>(this.sharedService.apiUrl('process/') + id)
    return process$;
  }
 
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  private log(message: string) {
    //this.messageService.add('HeroService: ' + message);
  }
}
